module.exports = __webpack_public_path__ + "img/fiche-aero.46d4693c.jpg";